module.exports = __webpack_public_path__ + "media/images/delivery-truck-c5608fcf7ff16d1784cdc2216c56fd11.png";